module.exports = __webpack_public_path__ + "static/paprica-lg-3ecd536148f4762961c2b647bc872cef.jpg";